import React from 'react';
import { Container, Row } from 'reactstrap';
import UserTable from './components/UserTable';
import BasicAccountTable from './components/BasicAccountTable';
import Panel from '../../../shared/components/Panel';
import PageHeader from '../../../shared/components/PageHeader';


const UserTablePage = () => (
  <Container>
    <Row>
      <PageHeader title="Users" subhead="Current User List" />
    </Row>
    <Row>
      <UserTable />
    </Row>
    <Row>
      <Panel lg={6} title="Create User Notes">
        <p>
          Access Levels (top level &#34;scope&#34;):
          <ul>
            <li>admin - full site access, only limited by specific roles</li>
            <li>agency - access to customerIdList and accountIdList, designated as a agency, can use roles </li>
            <ul>
              <li>Commonly used with selfServiceOnly flag set to TRUE</li>
            </ul>
            <li>customer - access to customerIdList and accountIdList, can use roles</li>
            <li>account - access to accountIdList, can use roles</li>
            <li>none - no access</li>
          </ul>
        </p>
        <br />
        <p>
          Roles and Scopes:
          <ul>
            <li>...Only = Access Control flags that end in ONLY and are set to TRUE will include menu items with that role and exclude others.  If two ONLY roles are setup, a menu item only needs one for it to display</li>
            <li>...Access = Access Control flags that end with ACCESS and are set to TRUE will include menu items with that flag along with any other default menu items</li>
            <li>...Role = Access Control flags that end in ROLE have specific logic in the code that applies to that specific role. e.g. hide/show a button</li>
            <li>[] or &apos;&apos; = Scopes with an empty array or empty string indicated that they are a default item.  No Role, Only, or Access Role is needed</li>
            <li>
              Known examples:
              <ul>
                <li>budgetControlAccess - Alows you to show Budget Control menu items with default menu items</li>
                <li>selfServiceOnly - Filters out reports we don&apos;t want to see and adds Budget Control to the Self Service section</li>
                <li>adminAccountRole - User has access to the Admin screens</li>
                <li>devRole - Access to pages in development</li>
              </ul>
            </li>
          </ul>
        </p>
        <br />
        <p>
          Access Control Examples:
          <ul>
            <li> &#34;agency &#34; access control: <code>{'{"scope": "agency", "customerIdList": [281, 285], "accountIdList": [266, 267, 268], "selfServiceOnly": true}'}</code></li>
            <li> &#34;customer &#34; access control: <code>{'{"scope": "customer", "customerIdList": [281, 285], "accountIdList": [266, 267, 268]}'}</code></li>
            <li> &#34;account &#34; access control: <code>{'{"scope": "account", "accountIdList": [316], "budgetControlAccess": true}'}</code></li>
          </ul>
        </p>
      </Panel>
      <Panel lg={6} title="Account and Customer ID's Reference">
        <BasicAccountTable />
      </Panel>
    </Row>
  </Container>
);

export default UserTablePage;
